module.exports = __webpack_public_path__ + "media/images/front/icon_like_on-7f4760d4345a76397f7c80de163fcde9.png";